module.exports = __webpack_public_path__ + "img/massage-1.c718264f.jpg";